import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import CurrencyInput from "react-currency-input";
import {
    Input, Label, Row, InputGroup, InputGroupAddon
} from 'reactstrap';
import Swal from "sweetalert2";
import { AvFeedback, AvForm, AvGroup, AvInput, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";
import { IMG_HOST } from "../../helper/host";
import { Upload } from "antd";
import ImgCrop from "antd-img-crop";
import customToast from "../../notification/customToast";
import '../../notification/toast.css'
import CKEditor from "react-ckeditor-component";



export class Add extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataAgenda: [],
            title_agenda: '',
            agenda_date: '',
            note: '',
            keyword: '',
            tipe: 'active',
            isLoading: true,
            auth: this.props.auth,
            disabledButton: false,
            loading: false,

        }
        this.handleChangePrice = this.handleChangePrice.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.onEditorStateChange = this.onEditorStateChange.bind(this);

    }
    onEditorStateChange(evt) {
        var newContent = evt.editor.getData();
        this.setState({
            note: newContent
        })
    };
    handleChangePrice(event, maskedvalue) {
        const target = event.target;
        const name = target.name;

        this.setState({ [name]: maskedvalue });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }



    handleSubmit = () => {
        this.setState({
            loading: true,
        })
        let form = {
            agenda_title: this.state.title_agenda,
            agenda_date: this.state.agenda_date,
            agenda_note: this.state.note,
            agenda_type: this.state.tipe,
            keyword: this.state.keyword
        }

        this.props.request("admin/agenda/tambah", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        isLoading: true,
                        title_agenda: '',
                        note: '',
                        tipe: '',
                    })
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                    this.loadData()
                    this.props.history.push('/agenda/list-agenda')
                } else {
                    if (Array.isArray(response.message)) {
                        response.message.map(item => {
                            customToast.error(item)
                            return true
                        })
                    } else {
                        customToast.error(response.message)
                    }
                    this.setState({ isLoading: false })
                }
                if (response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.failed,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                setTimeout(() => {
                    this.setState({ loading: false });
                }, 2000);
            });
    }

    loadData() {
        let formData = {
            blog_id: this.state.blog_id,
            auth: this.props.auth,

        }
        this.props.request("admin/agenda/list", formData)
            .then(response => {
                if (response.success) {
                    var result = response.data
                    this.setState({
                        dataAgenda: result.data,
                        modal: false,
                        auth: this.props.auth,
                        isLoading: false,
                        loading: false,
                    });

                }
            });
    }

    componentDidMount() {
        this.loadData()
    }
    componentWillReceiveProps(newProps) {
        if (newProps.auth !== this.state.auth) {
            this.setState({ auth: newProps.auth })
        }
    }



    render() {
        const { loading } = this.state;
        return (
            <Fragment>
                <Breadcrumb title="Tambah Agenda" parent="Agenda" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                        <h4>Tambah Agenda</h4>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4"><span>*</span>Title Agenda</label>
                                            <input name="title_agenda" value={this.state.title_agenda} className="form-control col-xl-8 col-md-7"
                                                   placeholder="Judul..."
                                                   type="text" required="" onChange={this.handleChange}/>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4"><span>*</span>Tanggal Agenda</label>
                                            <input name="agenda_date" value={this.state.agenda_date} className="form-control col-xl-8 col-md-7"
                                                   placeholder="Judul..."
                                                   type="date" required="" onChange={this.handleChange}/>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">Tipe Agenda</label>
                                            <select
                                                name="tipe"
                                                className="form-control col-xl-8 col-md-7"
                                                value={this.state.tipe}
                                                onChange={(event) => {
                                                    const target = event.target;
                                                    const value = target.value;
                                                    const name = target.name;
                                                    this.setState({
                                                        [name]: value
                                                    });
                                                }}>
                                                <option value="">Pilih Level</option>
                                                <option value="liburnasional">libur nasional</option>
                                                <option value="liburperusahaan">libur perusahaan</option>
                                                <option value="acara">acara</option>
                                            </select>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4"><span>*</span> Note</label>
                                            <div>
                                                <div>
                                                    <Input  className="form-control col-md-12"
                                                            type="textarea"
                                                            name="note"
                                                            id="note"
                                                            onChange={this.handleChange}
                                                            value={this.state.note}/>
                                                </div>
                                            </div>
                                        </div>
                                    <div className="pull-right">
                                        <button type="button" className="btn btn-primary" onClick={this.handleSubmit}
                                                disabled={loading}>
                                            {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{marginRight: "5px"}}
                                                />
                                            )}
                                            {loading && <span>Simpan</span>}
                                            {!loading && <span>Simpan</span>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Add
